import { adminProductRoutes as prdRoute } from '~/modules/admin-create/routes';

export default defineNuxtRouteMiddleware((to) => {
  const productId = to.params.id as string;
  if (to.path === prdRoute.detail(productId)) {
    return navigateTo(prdRoute.category(productId));
  }

  // if to detail path /:id, redirect to /:id/options
});
